import { Accordion, AccordionDetails, AccordionSummary, Box, Card, CardContent, Divider, styled } from '@ethings/ui-toolkit';
import { FC, ReactNode, useState } from 'react';

interface ExpandableCardProps {
  summary?: ReactNode;
  menu?: ReactNode;
  content?: ReactNode;
  unmountOnExit?: boolean;
}

const StyledAccordion = styled(Accordion)(({ theme }) => ({
  background: 'unset',
  '&:before': { display: 'none' },
  '& .MuiAccordionSummary-root': { minHeight: 'fit-content', padding: 0 },
  '& .MuiAccordionSummary-root.Mui-expanded': { minHeight: 'fit-content' },
  '& .MuiAccordionDetails-root': { padding: `${theme.spacing(1)} 0` },
  boxShadow: 'none',
}));

const StyledAccordionSummary = styled(AccordionSummary)({
  '& .MuiAccordionSummary-content': {
    justifyContent: 'space-between',
    margin: '0',
  },
  '& .MuiAccordionSummary-content.Mui-expanded': {
    margin: '0',
  },
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(180deg)',
  },
});

const StyledCardContent = styled(CardContent)(({ theme }) => ({
  '&.MuiCardContent-root': {
    paddingBottom: `${theme.spacing(2)}`,
    paddingRight: `${theme.spacing(1)}`,
    paddingLeft: `${theme.spacing(1)}`,
  },
}));

export const ExpandableCard: FC<ExpandableCardProps> = ({ content, summary, menu, unmountOnExit, ...rest }) => {
  const [expended, setExpended] = useState(false);

  return (
    <Card {...rest}>
      <StyledCardContent>
        <StyledAccordion expanded={expended} onChange={() => { setExpended((prev) => !prev); }} unmountOnExit={unmountOnExit}>
          <StyledAccordionSummary expandIcon={<></>}>{summary}</StyledAccordionSummary>
          <Box m={0} p={0} position='relative'>
            <AccordionDetails>
              <Divider />
              {content}
            </AccordionDetails>
          </Box>
        </StyledAccordion>
        {menu}
      </StyledCardContent>
    </Card>
  );
};
